<template>
  <v-layout row wrap justify-center align-center>
    <v-flex xs11 md11 lg11>
      <v-card class="rounded-lg mt-2">
        <v-card-title class="ml-2" v-if="e1 == 1"
          >{{ $t("onechat.new3") }}
          <v-spacer></v-spacer>
          <v-row justify="end">
            <v-col cols="12" sm="12" md="7" lg="7" class="mr-2">
              <v-text-field
                clearable
                outlined
                dense
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('consentlist.search')"
                color="#077893"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-title v-if="e1 == 2">
          <v-icon color="#077893" @click="Fn_BackIndex()" size="38">
            mdi-chevron-left
          </v-icon>
          {{ BotDetailName }}
          <v-spacer></v-spacer>
          <!-- <v-btn
            color="#077893"
            class="white--text mr-2"
            :loading="loadCSV"
            @click="Fn_DownloadCSV"
          >
            <v-icon dark> mdi-file-excel-outline </v-icon>
            {{ $t("search.text1") }}
          </v-btn> -->
        </v-card-title>
        <v-card-text elevation-0>
          <v-card class="elevation-0 pa-2">
            <v-stepper v-model="e1" outlined>
              <v-stepper-items>
                <v-stepper-content :step="1">
                  <v-data-table
                    :search="search"
                    style="max-height: 400px; overflow: auto"
                    outlined
                    hide-default-footer
                    calculate-widths
                    :headers="headers1"
                    :items="DataGroup"
                    :page.sync="PageConsent"
                    @page-count="PageCountConsent = $event"
                    :items-per-page="ItemPerPageConsent"
                  >
                    <template v-slot:[`item.GroupCreateTH`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.GroupCreateTH }}
                      </div>
                      <div v-else>
                        {{ item.GroupCreateEng }}
                      </div>
                      <div v-if="item.GroupCreateTH == '' || item.GroupCreateEng == ''">
                        -
                      </div>
                    </template>
                    <template v-slot:[`item.SendId`]="{ item }">
                      <div>
                        {{ item.SendId == "" ? "-" : item.SendId }}
                      </div>
                    </template>
                    <template v-slot:[`item.AccountId`]="{ item }">
                      <div>
                        <!-- <div v-else> -->
                        {{ item.AccountId }}
                        <!-- </div> -->
                        <!-- <v-icon
                          style="cursor: pointer"
                          @click="handleCopyClick(item.AccountId)"
                          color="#077893"
                          :key="iconState[item.AccountId] || 'copy'"
                          class="icon-transition"
                        >
                          {{
                            iconState[item.AccountId] === "copied"
                              ? "mdi mdi-check"
                              : "mdi mdi-content-copy"
                          }}
                        </v-icon> -->
                      </div>
                      <!-- <div>
                        {{ item.AccountId == "" ? "-" : item.AccountId}}
                      </div> -->
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        outlined
                        dense
                        dark
                        color="#077893"
                        @click="Fn_GetGroupOneChatSearch(item)"
                        >{{ $t("consentlist.detail") }}</v-btn
                      >
                    </template>
                  </v-data-table>
                  <v-pagination
                    :total-visible="7"
                    class="pt-2 pb-2"
                    circle
                    color="#077893"
                    v-model="PageConsent"
                    :length="PageCountConsent"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                  >
                  </v-pagination>
                </v-stepper-content>
                <v-stepper-content :step="2">
                  <v-layout row wrap justify-space-between align-baseline>
                    <v-flex xs12 lg5>
                      <v-flex xs12 lg12>
                        <!-- <div id="chart">
                          <center>
                            <apexchart
                              type="pie"
                              width="300"
                              :options="chartOptions"
                              :series="seriesPie"
                            ></apexchart>
                          </center>
                        </div> -->
                      </v-flex>
                    </v-flex>
                  </v-layout>
                  <v-container>
                    <v-layout row wrap justify-center align-center>
                      <v-row justify="end">
                        <v-col cols="12" sm="12" md="4" lg="4" class="mr-2">
                          <v-text-field
                            clearable
                            outlined
                            dense
                            v-model="searchHotpital"
                            append-icon="mdi-magnify"
                            :label="$t('consentlist.search')"
                            color="#077893"
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-flex xs12 lg12>
                        <v-data-table
                          :search="searchHotpital"
                          calculate-widths
                          :headers="headers2"
                          :items="TableConsent"
                          hide-default-footer
                          :page.sync="Page"
                          @page-count="PageCount = $event"
                          :items-per-page="ItemPerPage"
                        >
                          <template v-slot:[`item.OnePlatformId`]="{ item }">
                            <div>
                              <v-icon
                                style="cursor: pointer"
                                @click="handleCopyClick(item.OnePlatformId)"
                                color="#077893"
                                :key="iconState[item.OnePlatformId] || 'copy'"
                                class="icon-transition"
                              >
                                {{
                                  iconState[item.OnePlatformId] === "copied"
                                    ? "mdi mdi-check"
                                    : "mdi mdi-content-copy"
                                }}</v-icon
                              >
                            </div>
                            <!-- <div class="text-center">
                              {{ item.HospitalName ? item.HospitalName : "-" }}
                            </div> -->
                          </template>
                          <template v-slot:[`item.HospitalName`]="{ item }">
                            <div class="text-center">
                              {{ item.HospitalName ? item.HospitalName : "-" }}
                            </div>
                          </template>
                          <template v-slot:[`item.HospitalCode`]="{ item }">
                            <div class="text-center">
                              {{ item.HospitalCode ? item.HospitalCode : "-" }}
                            </div>
                          </template>
                          <template v-slot:[`item.UpdatedAt`]="{ item }">
                            <div v-if="$t('default') === 'th'">
                              {{ formatDate(item.UpdatedAt) }}
                            </div>
                            <div v-else>
                              {{ item.UpdatedAt }}
                            </div>
                          </template>
                          <template v-slot:[`item.CreatedAt`]="{ item }">
                            <div v-if="$t('default') === 'th'">
                              {{ formatDate(item.CreatedAt) }}
                            </div>
                            <div v-else>
                              {{ item.CreatedAt }}
                            </div>
                          </template>
                          <template v-slot:[`item.Status`]="{ item }">
                            <v-chip color="green" dark v-if="item.Status === 'OK'">{{
                              $t("onechat.status4")
                            }}</v-chip>
                            <v-chip color="error" dark v-else-if="item.Status === 'ER'">{{
                              $t("onechat.status3")
                            }}</v-chip>
                            <v-chip
                              color="warning"
                              dark
                              v-else-if="item.Status === 'WAIT'"
                              >{{ $t("onechat.status7") }}</v-chip
                            >
                            <v-chip
                              color="indigo"
                              dark
                              v-else-if="item.Status === 'Read'"
                              >{{ $t("onechat.status5") }}</v-chip
                            >
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="#077893"
                                  v-on="on"
                                  v-bind="attrs"
                                  :disabled="item.Status === 'OK'"
                                  small
                                  fab
                                  @click="Fn_ConsentUserDetailList(item)"
                                >
                                  <v-icon color="#fff">mdi mdi-menu</v-icon>
                                </v-btn>
                              </template>
                              <span>ดูรายละเอียด</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                        <v-pagination
                          :total-visible="7"
                          class="pt-2 pb-2"
                          circle
                          color="#077893"
                          v-model="Page"
                          :length="PageCount"
                          prev-icon="mdi-menu-left"
                          next-icon="mdi-menu-right"
                        >
                        </v-pagination>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card>
        </v-card-text>
      </v-card>
    </v-flex>
    <div>
      <v-dialog v-model="dialog" width="1200" scrollable persistent>
        <v-card class="rounded-lg">
          <v-card-title> รายละเอียดความยินยอม </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6">
            <v-layout>
              <v-flex>
                <v-card outlined class="roulded-lg">
                  <v-row justify="end" class="mt-2">
                    <v-col md="4" lg="4" class="mr-2">
                      <v-text-field
                        clearable
                        outlined
                        dense
                        v-model="searchConsent"
                        append-icon="mdi-magnify"
                        :label="$t('consentlist.search')"
                        color="#077893"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-title>
                    <v-flex lg12>
                      <v-data-table
                        :loading-text="$t('overlay.load')"
                        :loading="tableload"
                        :headers="headers3"
                        :items="ConsentList"
                        :search="searchConsent"
                        :page.sync="page"
                        :items-per-page="itemsPerPage"
                        hide-default-footer
                        @page-count="pageCount = $event"
                      >
                        <template v-slot:[`item.Id`]="{ item }">
                          <div>
                            {{ item.Id }}
                          </div>
                        </template>
                        <template v-slot:[`item.Status`]="{ item }">
                          <div>
                            <v-chip
                              v-if="item.Status == 'approve'"
                              class="ma-2"
                              color="green"
                              text-color="white"
                            >
                              ยินยอม
                              <!-- {{ item.Status }} -->
                            </v-chip>
                            <v-chip
                              v-else-if="item.Status == 'unapprove'"
                              class="ma-2"
                              color="red"
                              text-color="white"
                            >
                              ไม่ยินยอม
                              <!-- {{ item.Status }} -->
                            </v-chip>
                            <v-chip
                              v-else
                              class="ma-2"
                              color="primary"
                              text-color="white"
                            >
                              รอดำเนินการ
                              <!-- {{ item.Status }} -->
                            </v-chip>
                          </div>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="dialog = false">
              {{ $t("consentform.off") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-layout>
</template>

<script>
import DialogGeneralConsent from "@/components/dialog/DialogGeneralDashboardDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
// import DialogBotOnePlatformConsentDetailTable from "@/components/dialog/BotOnePlatform/DialogConsentUserDetailTable.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
import moment from "moment";
import "moment/locale/th"; // สำหรับภาษาไทย
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    DialogGeneralConsent,
    OverlaySearch,
    // DialogBotOnePlatformConsentDetailTable,
  },
  data: (vm) => ({
    num: 2,
    search: "",
    searchHotpital: "",
    iconState: {},
    DialogBotOnePlatformConsentDetailTable: false,
    loadingDownloadData: false,
    dialog: false,
    DataGroup: [
      // {
      //   no: "1",
      //   GroupSend: "กลุ่มส่งที่ 1",
      //   GroupCreateTH: "กลุ่มสร้างภาษาไทย 1",
      //   action: "ดูรายละเอียด",
      // },
      // {
      //   no: "2",
      //   GroupSend: "กลุ่มส่งที่ 2",
      //   GroupCreateTH: "กลุ่มสร้างภาษาไทย 2",
      //   action: "แก้ไข",
      // },
      // {
      //   no: "3",
      //   GroupSend: "กลุ่มส่งที่ 3",
      //   GroupCreateTH: "กลุ่มสร้างภาษาไทย 3",
      //   action: "ลบ",
      // },
    ],
    Page: 1,
    ItemPerPage: 10,
    PageConsent: 1,
    page: 1,
    tableload: true,
    pageCount: 0,
    itemsPerPage: 10,
    PageCountConsent: 0,
    ItemPerPageConsent: 5,
    e1: 1,
    Detail: [],
    Count: [],
    CountConsent: [],
    Policy: [],
    Consent: [],
    DataGroupOneChatSearch: [],
    TableConsent: [],
    PageCount: 0,
    DataConsent: [],
    DialogGeneral: false,
    PolicyHeader: [],
    dialogConsent: false,
    ConsentShort: "",
    ConsentDetail: "",
    RejectReason: "",
    loadCSV: false,
    ConsentDataFile: "",
    BotDetailName: "",
    searchConsent: "",
    DetailsConsent: [],
    ConsentDataTable: null,
    ConsentList: [],
    // tableZone
    series: [],
    seriesPie: [],
    seriesPieCountConsent: [],
    chartOptions: {
      chart: { width: 300, type: "pie" },
      labels: [],
      colors: ["#3f51b5", "#fb8c00", "#ff5252", "#4caf50"],
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: "gradient",
      },
      legend: {
        show: false,
      },
      tooltip: {
        enabled: false,
        theme: "dark",
      },
      responsive: [
        {
          breakpoint: 480,
          options: { chart: { width: 200 }, legend: { position: "bottom" } },
        },
      ],
    },
    chartOptionsCountConsent: {
      chart: { width: 300, type: "pie" },
      labels: [],
      colors: ["#4CAF50", "#F44336", "#FF9800", "#077893"],
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: "gradient",
      },
      legend: {
        show: false,
      },
      tooltip: {
        enabled: false,
        theme: "dark",
      },
      responsive: [
        {
          breakpoint: 480,
          options: { chart: { width: 200 }, legend: { position: "bottom" } },
        },
      ],
    },
  }),
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    ...mapGetters(["DataBotOnePlatform"]),
    _BotOnePlatformData: {
      get() {
        return this.DataBotOnePlatform || {};
      },
    },
    headers1() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "center",
          value: "no",
          sortable: false,
        },
        {
          text: "Account ID",
          value: "AccountId",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("BotOnePlatform.name"),
          value: "NameTh",
          align: "center",
          sortable: false,
        },
        {
          text: "Send ID",
          value: "SendId",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.detail"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
    headers2() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "center",
          value: "no",
          sortable: false,
        },
        {
          text: "OnePlateform ID",
          align: "center",
          value: "OnePlatformId",
          sortable: false,
        },
        {
          text: this.$i18n.t("BotOnePlatform.hospital_name"),
          align: "center",
          value: "HospitalName",
          sortable: false,
        },
        {
          text: this.$i18n.t("BotOnePlatform.hospital_code"),
          value: "HospitalCode",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("BotOnePlatform.CreatedAt"),
          value: "CreatedAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("BotOnePlatform.UpdatedAt"),
          value: "UpdatedAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("BotOnePlatform.consent_list"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
    headers3() {
      return [
        {
          text: "ลำดับ",
          align: "center",
          value: "no",
          width: "10%",
          sortable: false,
        },
        {
          text: "ID",
          align: "center",
          value: "Id",
          width: "30%",
          sortable: false,
        },
        {
          text: "Title",
          value: "Title",
          align: "center",
          width: "30%",
          sortable: false,
        },
        {
          text: "สถานะ",
          align: "center",
          value: "Status",
          width: "20%",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetConsentUserList();
  },
  methods: {
    formatDate(dateString) {
      return moment(dateString).locale("th").format("DD MMM YYYY HH:mm:ss");
    },
    handleCopyClick(id) {
      // ตั้งค่าสถานะเป็น 'copied' สำหรับไอคอนนี้
      this.Fn_CopyDetail(id);
      this.$set(this.iconState, id, "copied");

      // หลังจาก 2 วินาที เปลี่ยนกลับเป็นไอคอนเดิม
      setTimeout(() => {
        this.$set(this.iconState, id, "copy");
      }, 1200);
    },
    async Fn_CopyDetail(Id) {
      await navigator.clipboard.writeText(Id);
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    Fn_ConsentUserDetailList(item) {
      this.ConsentDataTable = item;
      this.ConsentList = item?.Consent;
      this.ConsentList = this.ConsentList.map((d, i) => {
        return {
          ...d,
          no: i + 1,
        };
      });
      this.tableload = false;
      this.dialog = true;
      // });
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
    Fn_BackIndex() {
      this.e1 = 1;
      this.$store.dispatch("SET_DATA_GROUP_ONECHAT", []);
    },
    Fn_LinkDownload(url) {
      var link = document.createElement("a");
      link.href = url;
      link.dispatchEvent(new MouseEvent("click"));
    },
    Fn_GetGroupOneChatSearch(item) {
      this.BotDetailName = "รายละเอียด";
      this.e1 = 2;
      this.Fn_GetDetailUserConsent(item);
    },
    async Fn_GetDetailUserConsent(item) {
      var body = {
        SendId: item.SendId,
        AccountId: item.AccountId,
        GroupSendId: this._BotOnePlatformData.Id,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      var headers = {
        Authorization: "Bearer " + auth,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      };
      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/GroupSend/${this._BotOnePlatformData.Id}/Users/${item.AccountId}/Details`,
          body,
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.TableConsent = response.data.Message;
            this.TableConsent = this.TableConsent.map((item, index) => {
              return {
                ...item,
                no: index + 1,
              };
            });
            // const filteredArray = originalObj.map(({ Consent, CreatedAt, ...rest }) => rest);
            this.ConsentDataTable = this.TableConsent.map(
              ({
                CreatedAt,
                HospitalCode,
                HospitalName,
                OnePlatformId,
                UpdatedAt,
                no,
                ...rest
              }) => rest
            );
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
          this.$router.push("/profile");
        });
    },
    async Fn_GetConsentUserList() {
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      var headers = {
        Authorization: "Bearer " + auth,
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      };
      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/GroupSend/${this._BotOnePlatformData.Id}/Users`,
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataGroup = response.data.Message;
            this.DataGroup = this.DataGroup.map((item, index) => {
              return {
                ...item,
                no: index + 1,
              };
            });
            this.$emit("loaded");
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.$emit("loaded");
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
          this.$router.push("/profile");
        });
    },
  },
  watch: {
    $route(to) {
      document.title = `APPLICATION_NAME - ${to.meta.title}`;
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", to.meta.icon);
    },
  },
};
</script>

<style></style>
